// extracted by mini-css-extract-plugin
export default {"sticky-tabs-container":"oVQVq","sticky-bottom-right":"rUH91"};